<template>
  <el-drawer
      title="结果集"
      direction="rtl"
      @open="init"
      @close="closeDrawer"
      :visible.sync="visible"
      :with-header="false"
      :destroy-on-close="true"
      size="70%">

    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <div class="drawer-header">
        <h2 class="title">结果列表</h2>
        <div class="toolbar text-align-reverse">
          <el-button type="primary" size="small" @click="addResult()" plain><i class="fa fa-plus"></i> 添加结果</el-button>
        </div>
      </div>
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>

      <el-table class="list-table" :data="resultList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <el-table-column prop="keyName" label="类型" width="80"></el-table-column>
        <el-table-column prop="name" label="分类" min-width="200"></el-table-column>
        <el-table-column prop="content" label="内容" min-width="360"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="toEdit(scope.row)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="toDelete(scope.row.id)" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    <paper-result-save :visible="addDialog" :result="result" @done="saveFinish"></paper-result-save>
    </el-card>
  </el-drawer>
</template>

<script>
  import {getPaperResultList, deletePaperResult} from '@/api/manage/result'
  import {handleConfirm} from '@utils/confirm'
  import PaperResultSave from "./PaperResultSave";

  export default {
    name: 'paperResult',
    components: {PaperResultSave},
    data() {
      return {
        resultList: [], // 结果列表
        result: {}, // 结果对象
        addDialog: false,
      }
    },
    props:{
      echoId:null,
      visible: false
    },
    methods: {
      init(){
        this.getResultList()
      },
      getResultList() {
        getPaperResultList(this.echoId).then(res => {
          this.resultList = res.data.result
        })
      },
      addResult() { // 添加试卷结果
        this.result = {paperId: this.echoId}
        this.addDialog = true
      },
      toDelete(id) {
        handleConfirm('此操作将删除该试题, 是否继续?').then(() => {
          deletePaperResult(id).then(resp => {
            this.$message.success(resp.data.message);
            this.getResultList();
          })
        })
      },
      toEdit(val) {
        this.addDialog = true
        this.result = val
      },
      closeDrawer(){
        this.$emit('done')
      },
      saveFinish(flag = false) {
        this.addDialog = false
        if (flag) {
          this.getResultList()
        }
      },
    }
  }
</script>
